import { generateAPI } from "../api.generator";

export type CreateR2UploadUrlResult = {
  uploadUrl: string;
  publicUrl: string;
  key: string;
  mediaAssetID: string;
  expiresIn: number;
};

export const createR2UploadUrl = generateAPI<
  {
    body: {
      field: string;
      collectionID: string;
      collection: string;
      contentType: string;
      originalFileName?: string;
    };
  },
  CreateR2UploadUrlResult
>("post", "media-asset/r2-upload-url");
